<template>
    <div
        class="sales-price"
        :data-id="product?.product.globalId"
        :class="[
            !product?.periodPrice ? 'sales-no-price' : '',
            product?.product.globalId === recommendedProduct
                ? 'sales-is-recommended'
                : '',
        ]"
    >
        <div
            class="sales-price-icon"
            v-if="product?.product.globalId === recommendedProduct"
        >
            <i class="material-icons">campaign</i>
        </div>

        <div class="sales-price-info">
            <span
                v-if="
                    product?.periodPrice &&
                    product?.periodPrice === product?.periodNormalPrice
                "
            >
                {{ Math.ceil(product?.periodPrice) }}:-
            </span>

            <span
                class="sales-extra-price-holder"
                v-if="
                    product?.periodPrice &&
                    product?.periodPrice !== product?.periodNormalPrice
                "
            >
                <span class="sales-normal-price"
                    >{{ Math.ceil(product?.periodNormalPrice) }}:-</span
                >
                <span class="sales-extra-price"
                    >{{ Math.ceil(product?.periodPrice) }}:-</span
                >
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ["product", "recommendedProduct"],
};
</script>

<style scoped>
.sales-price {
    display: flex;
    flex-direction: row;
}

.sales-price-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    color: #fff;
}

.sales-price-info {
    display: flex;
    justify-content: center;
    align-items: center;
}

.sales-is-recommended {
    border-radius: 6px;
    background: #0033ff;
    color: #fff;

    &:hover {
        background-color: #000;
        transition: 0.2s ease all;
    }

    .sales-extra-price {
        color: #fff;
    }
}

.sales-no-price {
    cursor: default;
    &:hover {
        background-color: #fff;
        transition: 0.2s ease all;
    }
}
</style>
